import DemoSignupComponent from '@forwardflow/components/DemoSignUp'

const DemoSignup = () => {
   return (
      <>
         <DemoSignupComponent />
      </>
   )
}
export default DemoSignup
